import { useListIntegrations } from "src/hooks/useListIntegrations";
import { LoadingPage } from "src/views/LoadingPage/LoadingPage";

import { DeployFirstIntegration } from "./DeployFirstIntegration";
import { WaitingForCustomers } from "./WaitingForCustomers";

export const CustomersEmptyState = () => {
  const { data: integrations, isLoading } = useListIntegrations();

  if (isLoading) {
    return <LoadingPage variant="table" />;
  }

  if ((integrations?.length ?? 0) > 0) {
    return <WaitingForCustomers />;
  }

  return <DeployFirstIntegration />;
};
